import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "reactstrap";
import { Calendar, dayjsLocalizer } from "react-big-calendar";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import dayjs from "dayjs";
import es from "dayjs/locale/es";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";

import "./Bookings.scss";
import axios from "axios";
import { Constants } from "../../Constants";
import moment from "moment";
dayjs.locale(es); // Configura dayjs para usar el idioma español

const getBookings = ({ date, view, operation }: any) => {
  const localeString = date.toLocaleString().slice(0, 10);
  // format 5/11/2023 cambiar por 2023-11-05
  // separar por / y armar el string
  let [day, month, year] = localeString.split("/");
  if (year.includes(",")) {
    year = year.slice(0, 4);
  }
  // si month o day tiene un solo digito agregar un 0 al inicio
  month = month.length === 1 ? `0${month}` : month;
  day = day.length === 1 ? `0${day}` : day;

  const instance = axios.create({ baseURL: Constants.BASE_URL });
  return instance
    .get(
      `/bookings?date=${year}-${month}-${day}&view=${view}&operation=${operation}`
    )
    .then((res: any) => res.data);
};

// $router->delete('/bookings/{id}', 'Bookings@remove');
const deleteBooking = (id: any) => {
  const instance = axios.create({ baseURL: Constants.BASE_URL });
  return instance.delete(`/bookings/${id}`).then((res: any) => res.data);
};

export default function Bookings() {
  const localizer = dayjsLocalizer(dayjs);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState<string>("day");
  const [minTime, setMinTime] = useState<any>(9);
  const [maxTime, setMaxTime] = useState<any>(18);
  const [bookings, setBookings] = useState<any[]>([]);
  const [operation, setOperation] = useState<string>("all");
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [visitToEdit, setVisitToEdit] = useState<any>({});
  const [hours, setHours] = useState<any[]>([]);

  useEffect(() => {
    fetch();
  }, [date, view, operation]);

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await getBookings({ date, view, operation });
      setBookings(response.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const eventPropGetter = useCallback((event: any) => {
    if (!event.is_active) {
      return {
        style: {
          backgroundColor: "#ff0000",
          color: "white",
        },
      };
    }
    if (event.date > new Date()) {
      return {
        style: {
          backgroundColor: "#ffff78",
        },
      };
    }

    return {
      style: {
        backgroundColor: "#7ae97a",
        color: "black",
      },
    };
  }, []);

  const fetchHours = async (date: string) => {
    try {
      if (!date) return;
      const response = await axios.get(
        `${Constants.BASE_URL}/bookings-date-available?date=${moment(
          date
        ).format("YYYY-MM-DD")}`
      );
      setHours(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async (id: any) => {
    confirmAlert({
      title: "Cancelar visita",
      message: "¿Esta seguro que desea cancelar la visita?",
      buttons: [
        {
          label: "Cancelar",
        },
        {
          label: "Confirmar",
          onClick: async () => {
            try {
              setLoading(true);
              await deleteBooking(id);
              await fetch();
              setLoading(false);
            } catch (error: any) {
              setLoading(false);
              toast.error(
                `Ocurrió un error al procesar la solicitud, reintentar`,
                {
                  position: toast.POSITION.BOTTOM_CENTER,
                  pauseOnHover: false,
                }
              );
            }
          },
        },
      ],
    });
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${Constants.BASE_URL}/bookings/${visitToEdit.id}`,
        {
          visit_date: visitToEdit.date,
          visit_hour: visitToEdit.time,
        }
      );
      await fetch();
      setLoading(false);
      setShowModalEdit(false);
    } catch (error: any) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <div className="page-content">
      <ToastContainer />
      {loading && <Loading />}
      <Container fluid>
        <Breadcrumbs title="Visitas" breadcrumbItem="Visitas" />
        <Row style={{ marginBottom: "1rem" }}>
          <Col>
            <label>Filtrar por operación</label>
            <select
              className="form-control"
              value={operation}
              onChange={(e) => setOperation(e.target.value)}
              style={{ width: "200px" }}
            >
              <option value="all">Ambos</option>
              <option value="buy">Comprar</option>
              <option value="rent">Alquilar</option>
            </select>
          </Col>
        </Row>
        <Row>
          <Col>
            <div>
              <Calendar
                date={date}
                onNavigate={(date: any) => {
                  setDate(date);
                }}
                localizer={localizer}
                events={bookings.map((booking: any) => ({
                  ...booking,
                  start: new Date(booking.start),
                  end: new Date(booking.end),
                }))}
                style={{ height: "80vh", color: "black" }}
                defaultView={view as any}
                views={["day", "week"]}
                onView={(view: any) => setView(view)}
                step={15}
                min={new Date(0, 0, 0, minTime, 0, 0)}
                max={
                  new Date(
                    0,
                    0,
                    0,
                    maxTime === 24 ? 23 : maxTime,
                    maxTime === 24 ? 59 : 0,
                    maxTime === 24 ? 59 : 0
                  )
                }
                eventPropGetter={eventPropGetter}
                onSelectEvent={(event: any) => {
                  setShowModalEdit(true);
                  setVisitToEdit(event);
                  fetchHours(event.date);
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={showModalEdit}
        toggle={() => setShowModalEdit(!showModalEdit)}
        centered
      >
        {loading && <Loading />}
        <div className="modal-header">
          <h5 className="modal-title mt-0">Editar visita</h5>
          <button
            type="button"
            onClick={() => setShowModalEdit(!showModalEdit)}
            className="btn-close"
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>Editar visita {visitToEdit.title}</p>
          {/*
            poder editar con un input date y un select el time visitToEdit.date y visitToEdit.time
          */}
          <div style={{ marginBottom: "1rem" }}>
            <p
              style={{
                marginBottom: "0px",
              }}
            >
              Fecha
            </p>
            <input
              type="date"
              value={dayjs(visitToEdit.date).format("YYYY-MM-DD")}
              className="w-100"
              onChange={(e) => {
                setVisitToEdit({
                  ...visitToEdit,
                  date: e.target.value,
                });
                fetchHours(e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "1rem" }}>
            <p
              style={{
                marginBottom: "0px",
              }}
            >
              Hora
            </p>
            <select
              className="form-control"
              value={visitToEdit.time}
              onChange={(e) => {
                setVisitToEdit({
                  ...visitToEdit,
                  time: e.target.value,
                });
              }}
            >
              {hours.map((hour: any) => (
                <option
                  key={hour.from}
                  value={moment(hour.from).format("HH:mm:ss")}
                >
                  {moment(hour.from).format("HH:mm")}
                </option>
              ))}
            </select>
          </div>

          <div>
            {visitToEdit.is_active ? (
              <button
                className="btn btn-danger"
                onClick={() => handleDelete(visitToEdit.id)}
                style={{ marginRight: "10px" }}
              >
                Cancelar visita
              </button>
            ) : null}
            <button
              className="btn btn-primary"
              onClick={() => handleUpdate()}
              style={{ marginRight: "10px" }}
            >
              Modificar
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShowModalEdit(false)}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
